<input type="range" orient="vertical" class="vertical-slider" min="0" max="100" step="1" (input)="onSliderChange($event)" [(ngModel)]="volume">
